import orderBy from 'lodash/orderBy';
import { ClientEventOffering } from '@pass-frontend/data-access/state-management/apollo';
import {
  SORT_CRITERIA,
  SORT_DIRECTION,
  SortOfferingsDataFn,
} from '@pass-frontend/data-access/types';
import { EventSortCriteria } from '@pass-frontend/features/social/data-access';

export const sortEventOfferingsData: SortOfferingsDataFn<
  ClientEventOffering,
  EventSortCriteria
> = (
  offeringsList: ClientEventOffering[],
  sortCriterion: EventSortCriteria = SORT_CRITERIA.DISTANCE,
  sortDirection = SORT_DIRECTION.ASC,
) => {
  const sortDirectionLowerCase = sortDirection.toLowerCase() as 'asc' | 'desc';
  if (sortCriterion === SORT_CRITERIA.DISTANCE) {
    return orderBy(
      offeringsList,
      ['location.distanceFromMember', 'startDateTimeISO'],
      [sortDirectionLowerCase, sortDirectionLowerCase],
    );
  } else if (sortCriterion === SORT_CRITERIA.DATE) {
    return orderBy(
      offeringsList,
      ['startDateTimeISO', 'location.distanceFromMember'],
      [sortDirectionLowerCase, sortDirectionLowerCase],
    );
  }
  console.warn(
    'INVALID SORTING',
    sortCriterion,
    'must be',
    SORT_CRITERIA.DISTANCE,
    'or',
    SORT_CRITERIA.DATE,
  );
  return offeringsList;
};
